// extracted by mini-css-extract-plugin
export var maxcontent = "MaxContent-module--maxcontent--1RxUJ";
export var fadeOutAnimation = "MaxContent-module--fadeOutAnimation--1eInh";
export var fadeInAnimation = "MaxContent-module--fadeInAnimation--1Je-Y";